import { HostListener } from '@angular/core';
import { RouterStateSnapshot } from '@angular/router';

export abstract class ComponentCanDeactivate {
  public abstract canDeactivate(nextState?: RouterStateSnapshot): boolean;

  @HostListener('window:beforeunload', ['$event'])
  public unloadNotification($event: any) {
    if (!this.canDeactivate()) {
      $event.returnValue = true;
    }
  }
}
